import { DOCSTATUS } from '@/const.js'
import { useCurrentUser } from '@/services/useCurrentUser'

export const useStatus = () => {
  const convertStatus = statusCode => {
    const { currentUser } = useCurrentUser()
    if (statusCode === null) statusCode = 0
    switch (statusCode) {
      case DOCSTATUS.IN_PREPARATION: // 下書き
        return 1
      case DOCSTATUS.REJECTES: // 差し戻し
        return 3
      case DOCSTATUS.APPROVED: // 承認済
        return 4
      default: // 承認待ち
        if(currentUser.role.is_authorizer){
          if(currentUser.role.rank < statusCode){
            // 自分が承認済
            return 5
          }else if(currentUser.role.rank == statusCode){
            // 自分が承認する番
            return 2
          }else{
            // まだ自分の番じゃない承認待ち
            return 6
          }
        }
        return 2
    }
  }

  const getClassName = (status, isWaitingUser = false) => {
    if (isWaitingUser) {
      return 'bg-white'
    }
    switch (status) {
      case 1: // edit
        return ''
      case 2: // wait
        return 'bg-blue btn-filled'
      case 3: // reject
        return ''
      case 4: // approval
        return 'bg-blue btn-filled'
      case 5: // 自分が承認済
        return ''
      case 6: // まだ自分の番じゃない承認待ち
        return ''
      default:
        return 'border-dotted'
    }
  }

  const getIcon = status => {
    switch (status) {
      case 1: // 作成
        return require('@/assets/icons/edit-circle.svg')
      case 2: // 更新
        return require('@/assets/icons/edit-yellow-circle.svg')
      case 3: // 削除
        return require('@/assets/icons/reject-cancel.svg')
      case 4: // 承認申請
        return require('@/assets/icons/approved-yellow.svg')
      case 5: // 取り下げ
        return require('@/assets/icons/withdrawal.svg')
      case 6: // 差し戻し
        return require('@/assets/icons/rejected.svg')
      case 7: // 承認
        return require('@/assets/icons/approved.svg')
      default:
        return ''
    }
  }

  const getTypeIcon = status => {
    switch (status) {
      case 1: // 予算
        return require('@/assets/icons/money-circle-red.svg')
      case 2: // 領収書
        return require('@/assets/icons/receiptred.svg')
      case 3: // 申請書
        return require('@/assets/icons/lightning-red.svg')
      case 4: // 報告書
        return require('@/assets/icons/lightning-red.svg')
      case 5: // 記録簿
        return require('@/assets/icons/lightning-red.svg')
      default:
        return ''
    }
  }

  return { convertStatus, getIcon, getClassName, getTypeIcon }
}
